import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { STUDENT_TOKEN, USER_INFO } from '../../constants';
import studentApi from './studentApi';

const MagicLinkLogin = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const authenticateWithMagicLink = async () => {
      try {
        setLoading(true);
        setError('');

        // Call the magic link login API
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/student/magic-login/${token}/`);
        const data = await response.json();

        if (data.success) {
          const { user, token: authToken } = data.data;
          
          // Save user data in localStorage
          localStorage.setItem(STUDENT_TOKEN, authToken);
          localStorage.setItem(USER_INFO, JSON.stringify(user));
          
          // Login the user
          await login(user, authToken, 'student');
          
          // Navigate to dashboard
          navigate('/student/dashboard', { replace: true });
        } else {
          setError(data.message || 'Invalid magic link');
        }
      } catch (err) {
        console.error('Magic link authentication error:', err);
        setError('Failed to authenticate with magic link');
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      authenticateWithMagicLink();
    } else {
      setError('No magic link token provided');
      setLoading(false);
    }
  }, [token, navigate, login]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
              <p className="mt-4 text-sm text-gray-600">Authenticating with magic link...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                Magic Link Error
              </h2>
              <p className="mt-2 text-center text-sm text-gray-600">
                {error}
              </p>
              <div className="mt-6">
                <button
                  onClick={() => navigate('/student/login')}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Go to Student Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default MagicLinkLogin;
